/** Action Types */
export const SIGNALR_CONNECT = 'SIGNALR_CONNECT';
export const SIGNALR_RECONNECT = 'SIGNALR_RECONNECT';
export const SIGNALR_CONNECTED = 'SIGNALR_CONNECTED';
export const SIGNALR_CONNECTING = 'SIGNALR_CONNECTING';
export const SIGNALR_CONNECTION_FAILED = 'SIGNALR_CONNECTION_FAILED';

export const SIGNALR_DISCONNECT = 'SIGNALR_DISCONNECT';
export const SIGNALR_DISCONNECTING = 'SIGNALR_DISCONNECTING';
export const SIGNALR_DISCONNECTED = 'SIGNALR_DISCONNECTED';

export const SIGNALR_ERRORED = 'SIGNALR_ERRORED';
export const SIGNALR_RECEIVE_MESSAGE = 'SIGNALR_RECEIVE_MESSAGE';
export const SIGNALR_INVOKE_MESSAGE = 'SIGNALR_RECEIVE_MESSAGE';

/** Statuses */
export const SIGNALR_STATUS_DISCONNECTED = 0;
export const SIGNALR_STATUS_CONNECTING = 1;
export const SIGNALR_STATUS_CONNECTED = 2;
export const SIGNALR_STATUS_DISCONNECTING = 3;
export const SIGNALR_STATUS_ERRORED = 4;



// WEBPACK FOOTER //
// ./src/api/SignalR/state/types.js